import {BackendApi} from '@/services/backend_api'

export default {
  get (id) {
    return BackendApi.getAnonymousClient().get(`parks/${id}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  cget () {
    return BackendApi.getAnonymousClient().get(`parks/`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  post (park) {
    return BackendApi.getClient().post('parks/', park)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  put (park) {
    return BackendApi.getClient().put(`parks/${park.id}`, park)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  getParkByUserId (userId) {
    return BackendApi.getAnonymousClient().get(`parks/?userId=${userId}`)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  withApprovedParkQuizPerYear () {
    return BackendApi.getClient().get(`parks/with-approved-park-quiz-per-year`)
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/park.js